export default __webpack_public_path__ + "static/icon-high-leg-2a564cb8d282639fb7552cc69029ce82.webp";